export default __webpack_public_path__ + "static/media/4.42a6fc6e.png";